/*
 * Lazy load background images using IntersectionObserver
 * https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
 * Ussage: Add the class "lazyload-background" to the element and set the data-bgimage attribute to the image URL
 * <div class="lazyload-background" data-bgimage="image.jpg"></div>
*/
jQuery(document).ready(function () {
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            const bgImage = entry.target.dataset.bgimage;

            if (bgImage) {
              entry.target.style.backgroundImage = `url('${bgImage}')`;
            }

            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '150px' } // Load images before they come into the viewport
    );

    // Observe all elements with the .lazyload-background class
    const lazyBackgroundElements = document.querySelectorAll('.lazyload-background');
    lazyBackgroundElements.forEach(function (element) {
      if (element.dataset.bgimage) {
        observer.observe(element);
      }
    });

    // Use requestIdleCallback to load images when the browser is idle
    if ('requestIdleCallback' in window) {
      requestIdleCallback(
        function () {
          lazyBackgroundElements.forEach(function (element) {
            const bgImage = element.dataset.bgimage;

            if (bgImage && !element.style.backgroundImage) {
              element.style.backgroundImage = `url('${bgImage}')`;
              observer.unobserve(element);
            }
          });
        },
        { timeout: 2000 } // Fallback if the browser is busy for more than 2 seconds
      );
    }
  } else {
    // Fallback for browsers without IntersectionObserver support
    const lazyBackgroundElements = document.querySelectorAll('.lazyload-background');
    lazyBackgroundElements.forEach(function (element) {
      const bgImage = element.dataset.bgimage;
      if (bgImage) {
        element.style.backgroundImage = `url('${bgImage}')`;
      }
    });
  }
});